<template>
  <div class="home-monitor-ranking">
    <ListHeader :title="'监控公司排行'" :isShowTab="true" :optionTab="'all'" @change="changeMonitor"></ListHeader>
    <div v-loading="isIndexLoading" class="index">
      <SnNewRanking :data="homeIndexData" :optionTab="optionTabData" @onBarClick="onBarClick">指数排行</SnNewRanking>
      <div class="no-data-container" v-if="!homeIndexData.length && !isIndexLoading">
        <no-data></no-data>
      </div>
      <ListFooter :show-name="homeIndexData.length > 5" :footerName="'查看完整排行'" :locationData="'right'" @seeMore="seeAllIndex"></ListFooter>
    </div>
    <div v-loading="isRiseLoading" class="index">
      <SnNewRanking :data="homeIndexRiseData" :optionTab="optionTabData" @onBarClick="onBarClick">指数增长排行</SnNewRanking>
      <div class="no-data-container" v-if="!homeIndexRiseData.length && !isRiseLoading">
        <no-data></no-data>
      </div>
      <ListFooter :show-name="homeIndexRiseData.length > 5" :footerName="'查看完整排行'" :locationData="'right'" @seeMore="seeAllIndexRise"></ListFooter>
    </div>
  </div>
</template>

<script>
import ListHeader from '@/components/common/ListHeader';
import SnNewRanking from '@/components/common/SnNewRanking';
import ListFooter from '@/components/common/ListFooter';
import authService from '@/services/authService';
import questionQuery from '@/rest/questionQuery';
import NoData from '@/components/common/NoData';

export default {
  data() {
    return {
      timer: null,
      isIndexLoading: false,
      isRiseLoading: false,
      homeIndexData: [],
      homeIndexRiseData: [],
      username: '',
      optionTabData: 'all'
    };
  },
  methods: {
    changeMonitor(res) {
      this.optionTabData = res;
      this.getHomeIndexData();
      this.getHomeIndexRiseData();
    },
    seeAllIndex() {
      this.$router.push({
        name: 'top-news-detail-page', 
        query: {
          optionTabData: this.optionTabData
        }
      });
    },
    seeAllIndexRise() {
      this.$router.push({
        name: 'top-news-detail-page', 
        query: {
          riskOptionTabData: this.optionTabData
        }
      });
    },
    onBarClick(name) {
      this.$router.push({
        name: 'result-page', 
        query: {
          q: name
        }
      });
    },
    getHomeIndexRiseData() {
      questionQuery.homeIndexRise(this.username, this.optionTabData, false).then(res => {
        this.isRiseLoading = false;
        this.homeIndexRiseData = res.map(item => {
          return {
            name: item.entity,
            num: item.count
          };
        });
      });
    },
    getHomeIndexData() {
      questionQuery.homeIndex(this.username, this.optionTabData, false).then(res => {
        this.isIndexLoading = false;
        this.homeIndexData = res.map(item => {
          return {
            name: item.entity,
            num: item.count
          };
        });
      });
    },
    getHomeIndexRise() {
      this.isRiseLoading = true;
      this.getHomeIndexRiseData();
    },
    getHomeIndex() {
      this.isIndexLoading = true;
      this.getHomeIndexData();
    }
  },
  components: {
    ListHeader,
    SnNewRanking,
    ListFooter,
    NoData
  },
  mounted() {
    this.username = authService.getLoggedUserName();
    this.getHomeIndex();
    this.getHomeIndexRise();
    this.timer = window.setInterval(() => {
      this.getHomeIndexRiseData();
      this.getHomeIndexData();
    }, 1000 * 60);
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);        
    }
  }
};
</script>

<style lang="scss" scoped>
  .home-monitor-ranking {
    border-radius: 8px;
    overflow: hidden;
    .index {
      position: relative;
      .no-data-container {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        .no-data {
          font-size: 18px;
        }
      }
    }
  }
</style>

